import BrandingService from "@/services/brandingService";

export const BrandingApi = {
  loadPageData: async () => {
    const [current, history] = await Promise.all([
      BrandingService.getCurrent(),
      BrandingService.getHistory(),
    ]);

    return {
      current,
      history,
    };
  },

  getCurrent: async () => {
    return BrandingService.getCurrent();
  },

  // A page change/page-size change only needs the history list — refetching
  // `current` (draft/published config) alongside it would wipe unrelated
  // in-flight form state for no reason.
  getHistoryPage: async ({ page, perPage }) => {
    return BrandingService.getHistory({ page, perPage });
  },

  saveDraft: async (payload) => {
    return BrandingService.saveDraft(payload);
  },

  publishDraft: async () => {
    return BrandingService.publishDraft();
  },

  discardDraft: async () => {
    return BrandingService.discardDraft();
  },

  discardDraftConfig: async () => {
    return BrandingService.discardDraftConfig();
  },

  uploadAsset: async (params) => {
    return BrandingService.uploadAsset(params);
  },

  deleteAsset: async (params) => {
    return BrandingService.deleteAsset(params);
  },

  rollbackToHistory: async (historyId) => {
    return BrandingService.rollbackToHistory(historyId);
  },
};

export default BrandingApi;